import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {IDesbloqOrdenCalidad} from '../modelos/IDesbloqueoOrdenBalCalidad';

@Injectable({
  providedIn: 'root'
})
export class DesbloqueoOrdenBalanzaCalidadService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<IDesbloqOrdenCalidad[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.desbloqueoOrdenBalanzaCalidad.obtenerTodo
    );
  }

  crear(request: IDesbloqOrdenCalidad) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.desbloqueoOrdenBalanzaCalidad.crear,
      request
    );
  }

}
